import React, { useState } from "react";
import { SocioServiceFirestore } from "../../services/SocioServiceFirestore";
import { LigaServiceFirestore } from "../../services/LigaServiceFirestore";

/**
 * Utilidad para corregir el campo ligaAsignada de todos los socios de una liga,
 * asignando el ID real de la liga (no el nombre) a todos los socios que tengan el nombre de la liga o valor incorrecto.
 *
 * USO: Añade temporalmente esta página a tu app, accede a ella, selecciona la liga y pulsa el botón para corregir.
 * Luego puedes eliminar el archivo.
 */

const FixSociosLiga: React.FC = () => {
  const [status, setStatus] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [ligas, setLigas] = useState<any[]>([]);
  const [selectedLigaId, setSelectedLigaId] = useState<string>("");
  const [selectedLigaNombre, setSelectedLigaNombre] = useState<string>("");

  React.useEffect(() => {
    LigaServiceFirestore.getAll().then(setLigas);
  }, []);

  const handleFix = async () => {
    if (!selectedLigaId || !selectedLigaNombre) {
      setStatus("Selecciona una liga.");
      return;
    }
    setLoading(true);
    setStatus("");
    try {
      const socios = await SocioServiceFirestore.getAll();
      let count = 0;
      for (const socio of socios) {
        // Si el socio tiene el nombre de la liga en vez del id, o el campo está vacío o mal escrito
        if (
          (socio.ligaAsignada || "").trim() === selectedLigaNombre.trim() ||
          (socio.ligaAsignada || "").trim() === "" ||
          (socio.ligaAsignada || "").trim().toLowerCase() === selectedLigaNombre.trim().toLowerCase()
        ) {
          if (!socio.id) continue;
          await SocioServiceFirestore.update(socio.id, { ligaAsignada: selectedLigaId });
          count++;
        }
      }
      setStatus(`Actualizados ${count} socios para la liga '${selectedLigaNombre}'.`);
    } catch (e) {
      setStatus("Error: " + (e as any).message);
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 500, margin: "40px auto", padding: 24, background: "#fff", borderRadius: 10, boxShadow: "0 2px 10px #0001" }}>
      <h2>Corregir Socios de Liga</h2>
      <div style={{ marginBottom: 18 }}>
        <label>Liga:&nbsp;
          <select
            value={selectedLigaId}
            onChange={e => {
              setSelectedLigaId(e.target.value);
              const liga = ligas.find(l => l.id === e.target.value);
              setSelectedLigaNombre(liga ? liga.nombre : "");
            }}
            style={{ padding: 8, borderRadius: 5 }}
          >
            <option value="">Selecciona una liga</option>
            {ligas.map(liga => (
              <option key={liga.id} value={liga.id}>{liga.nombre}</option>
            ))}
          </select>
        </label>
      </div>
      <button onClick={handleFix} disabled={loading || !selectedLigaId} style={{ padding: 10, borderRadius: 5, background: '#0f3460', color: '#fff', fontWeight: 600 }}>
        {loading ? "Corrigiendo..." : "Corregir socios de esta liga"}
      </button>
      <div style={{ marginTop: 20, color: status.startsWith("Error") ? "#b00" : "#070" }}>{status}</div>
      <p style={{marginTop: 24, color: '#555', fontSize: 13}}>
        Esto actualizará el campo <b>ligaAsignada</b> de todos los socios que tengan el nombre de la liga, vacío, o valor incorrecto,<br />
        y lo pondrá con el <b>ID real</b> de la liga seleccionada.<br />
        Luego podrás crear carreras con los participantes correctos automáticamente.
      </p>
    </div>
  );
};

export default FixSociosLiga;
